var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcedures(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 7,
    fill: "#959CA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 15.5H12V20.5H15.9453C16.0625 20.5 16.1406 20.5781 16.2188 20.6953L17 22.2578L18.9141 18.3516C19.1484 17.9219 19.8125 17.9219 20.0469 18.3516L21.1016 20.5H23.875C24.1875 20.5 24.5 20.8125 24.5 21.125C24.5 21.4766 24.1875 21.75 23.875 21.75H20.3594L19.5 20.0312L17.5469 23.9375C17.3125 24.4062 16.6484 24.4062 16.4141 23.9375L15.3594 21.7891L12 21.75V25.5H27V15.5ZM28.875 11.75H10.125C9.07031 11.75 8.25 12.6094 8.25 13.625V27.375C8.25 28.4297 9.07031 29.25 10.125 29.25H28.875C29.8906 29.25 30.75 28.4297 30.75 27.375V13.625C30.75 12.6094 29.8906 11.75 28.875 11.75ZM28.25 26.75H10.75V14.25H28.25V26.75Z",
    fill: "#C080B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedures);
export default __webpack_public_path__ + "static/media/procedures.faa73143.svg";
export { ForwardRef as ReactComponent };